import toast from "toastr";
// import 'toastr/build/toastr.min.css'
toast.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-left",
  preventDuplicates: false,
  // "onclick": null,
  showDuration: 500,
  hideDuration: 500,
  timeOut: 3000,
  extendedTimeOut: 3000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

class Notification {
  static success(msg: any) {
    Notification.setToastTime(msg);
    return toast.success(msg);
  }
  static error(msg: any) {
    Notification.setToastTime(msg);
    return toast.error(msg);
  }
  static warning(msg: any) {
    Notification.setToastTime(msg);
    return toast.warning(msg);
  }

  static setToastTime(msg: string) {
    // generate toast time out by num words of message
    const numWords = msg.split(" ").length;
    const calcTime = numWords * 400;
    const time = calcTime > 3000 ? calcTime : 3000;
    toast.options.timeOut = time;
    toast.options.extendedTimeOut = time;
  }
}
export default Notification;
